import React from 'react';
import { useFeatureFlags } from '../FeatureFlagContext';
import AccordionSubMenu from './AccordionSubMenu';
import MenuLink from './MenuLink';
import { StyledMenuItem } from './StyledMenuComponents';
export default function AlertsMenu({ outages, roles, hasActiveDepositAccounts, routeInEmber, routeLinks, closeMenu, closeAccordion, activeAccordion, updateAccordionState, allRestrictedCCAccounts, hasCreditPlanRelationship, }) {
    const featureFlags = useFeatureFlags();
    const { isWealthManagement, isCreditCardEnabled, isAutoAlertsEnabled, isCreditScoreEnabled, } = featureFlags;
    const isBankDown = outages.bank;
    const isInvestDown = outages.invest;
    const isWealthDown = outages.wealth;
    const shouldRenderBankLink = roles.bank && hasActiveDepositAccounts && !isBankDown;
    const shouldRenderVehiclesLink = roles.auto && isAutoAlertsEnabled;
    const shouldRenderInvestLink = isWealthManagement
        ? (roles.invest && !isInvestDown) || (roles.wealth && !isWealthDown)
        : roles.invest && !isInvestDown;
    const shouldRenderCreditCardLink = isCreditCardEnabled &&
        roles.creditCard &&
        !outages.creditCard &&
        !allRestrictedCCAccounts;
    const shouldRenderCreditScoreLink = hasCreditPlanRelationship && isCreditScoreEnabled;
    const visibleLobs = [
        { name: 'bank', visible: shouldRenderBankLink, outage: outages.bank },
        { name: 'invest', visible: shouldRenderInvestLink, outage: outages.invest },
        {
            name: 'creditCard',
            visible: shouldRenderCreditCardLink,
            outage: outages.creditCard,
        },
        {
            name: 'vehicles',
            visible: shouldRenderVehiclesLink,
        },
        {
            name: 'creditScore',
            visible: shouldRenderCreditScoreLink,
        },
    ].filter(obj => obj.visible);
    const areAllVisibleLobsDown = visibleLobs.every(obj => obj.outage);
    if (areAllVisibleLobsDown) {
        return React.createElement(React.Fragment, null);
    }
    const showAccordion = visibleLobs.length > 1;
    if (showAccordion) {
        return (React.createElement(AccordionSubMenu, { accordionId: "alerts", shouldRenderBankLink: shouldRenderBankLink, shouldRenderInvestLink: shouldRenderInvestLink, shouldRenderVehiclesLink: shouldRenderVehiclesLink, shouldRenderCreditCardLink: shouldRenderCreditCardLink, shouldRenderCreditScoreLink: shouldRenderCreditScoreLink, isInvest: roles.invest, isWealthClient: roles.wealth, isWealthDown: isWealthDown, isInvestDown: isInvestDown, instanceKey: "alerts-submenu", title: "Alerts", ariaLabel: "Alerts", linkInfo: routeLinks.alerts, routeInEmber: routeInEmber, closeMenu: closeMenu, closeAccordion: closeAccordion, activeAccordion: activeAccordion, updateAccordionState: updateAccordionState }));
    }
    if (shouldRenderBankLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.alerts.bankUrl, text: routeLinks.alerts.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    if (shouldRenderInvestLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.alerts.investUrl, text: routeLinks.alerts.content, closeMenu: closeMenu })));
    }
    if (shouldRenderCreditCardLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.alerts.creditCardUrl, text: routeLinks.alerts.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    if (shouldRenderVehiclesLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.alerts.vehiclesUrl, text: routeLinks.alerts.content, closeMenu: closeMenu })));
    }
    if (shouldRenderCreditScoreLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.alerts.creditScoreUrl, text: routeLinks.alerts.content, closeMenu: closeMenu })));
    }
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=AlertsMenu.js.map